import React from 'react';
import { Plus, Calendar, Edit2, Trash2 } from 'lucide-react';
import { usePreview } from '../../context/PreviewContext';
import { Button } from '../../components/ui/button';
import NutritionGraphs from '../../components/NutritionGraphs';

/**
 * Preview Nutrition Page
 * Read-only nutrition data with mock data
 */
const PreviewNutritionPage = () => {
  const { nutritionRecords, treatments } = usePreview();

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold text-slate-900">Nutrition & Deficiencies</h1>
          <p className="text-slate-500 mt-1">Track your vitamin and mineral levels</p>
        </div>
        <Button disabled className="opacity-50 cursor-not-allowed">
          <Plus className="h-4 w-4 mr-2" />
          Add Results
        </Button>
      </div>

      {/* Charts Section - NutritionGraphs includes SupplementTimeline internally */}
      <NutritionGraphs
        records={nutritionRecords}
        supplements={treatments}
      />

      {/* History Section */}
      <div className="bg-white rounded-xl border border-slate-200">
        <div className="px-6 py-4 border-b border-slate-100">
          <h2 className="text-lg font-semibold text-slate-900">History</h2>
        </div>
        <div className="divide-y divide-slate-100">
          {nutritionRecords.slice().reverse().map(record => (
            <div key={record.id} className="px-6 py-4">
              <div className="flex items-start justify-between">
                <div>
                  <div className="flex items-center gap-2 mb-2">
                    <Calendar className="h-4 w-4 text-slate-400" />
                    <span className="font-medium text-slate-900">
                      {new Date(record.date).toLocaleDateString('en-AU', { 
                        day: '2-digit', 
                        month: 'short', 
                        year: 'numeric' 
                      })}
                    </span>
                  </div>
                  <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 text-sm">
                    <div>
                      <span className="text-slate-500">Vitamin D</span>
                      <p className="font-medium">{record.vitamin_d} nmol/L</p>
                    </div>
                    <div>
                      <span className="text-slate-500">B12</span>
                      <p className="font-medium">{record.b12} pmol/L</p>
                    </div>
                    <div>
                      <span className="text-slate-500">Folate</span>
                      <p className="font-medium">{record.folate} nmol/L</p>
                    </div>
                    <div>
                      <span className="text-slate-500">Ferritin</span>
                      <p className="font-medium">{record.ferritin} ng/mL</p>
                    </div>
                  </div>
                  {record.notes && (
                    <p className="text-sm text-slate-500 mt-2 italic">{record.notes}</p>
                  )}
                </div>
                <div className="flex gap-2">
                  <button disabled className="p-2 text-slate-300 cursor-not-allowed">
                    <Edit2 className="h-4 w-4" />
                  </button>
                  <button disabled className="p-2 text-slate-300 cursor-not-allowed">
                    <Trash2 className="h-4 w-4" />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PreviewNutritionPage;
